import { jsx as _jsx } from "react/jsx-runtime";
import { FormControlLabel, RadioGroup as MUIRadioGroup, Radio, } from '@mui/material';
const RadioGroup = ({ loopArray, value, onChange }) => {
    return (_jsx(MUIRadioGroup, Object.assign({ row: true, value: value, sx: { m: '10px 0px' } }, { children: loopArray.map((item, index) => (_jsx(FormControlLabel, { value: item, control: _jsx(Radio, { onChange: () => onChange(item) }), label: item.charAt(0).toUpperCase() + item.slice(1) }, index))) })));
};
export default RadioGroup;
